 export interface ITransplantDetailsRequest {
}
